var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 423,
    viewBox: "0 0 423 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 423,
    rx: 110.865,
    fill: "#FF9800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.887 209.874C222.957 217.005 216.973 223.013 209.87 221.939C205.443 221.255 201.843 217.64 201.161 213.196C200.091 206.064 206.075 200.057 213.178 201.131C217.606 201.815 221.206 205.429 221.887 209.874Z",
    fill: "#0B1023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.52 117.853V196.784C222.228 196.54 221.936 196.345 221.644 196.149C218.725 194.244 215.271 193.121 211.524 193.121C207.778 193.121 204.275 194.244 201.405 196.149C201.113 196.345 200.821 196.54 200.529 196.784V139.686L138.889 186.087L172.944 207.921C173.674 208.409 174.161 209.239 174.161 210.118V229.558C174.161 231.61 171.923 232.88 170.171 231.805L113.444 196.735C110.282 194.879 108.238 191.509 107.995 187.797C107.8 184.085 109.406 180.519 112.374 178.321L204.908 108.719C209.384 105.349 215.952 105.739 219.941 110.428C221.693 112.48 222.52 115.166 222.52 117.853Z",
    fill: "#0B1023"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.162 213.195C200.091 206.064 206.075 200.056 213.178 201.131C217.606 201.815 221.206 205.429 221.887 209.874C222.957 217.005 216.973 223.013 209.87 221.938C205.443 221.254 201.843 217.64 201.162 213.195Z",
    fill: "#0B1023"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.005 235.224C315.199 238.936 313.594 242.502 310.626 244.7L218.092 314.302C216.146 315.767 213.811 316.5 211.475 316.5C209.821 316.5 208.118 316.109 206.562 315.328C202.864 313.472 200.48 309.613 200.48 305.412V226.237C200.772 226.481 201.064 226.676 201.356 226.872C204.275 228.777 207.729 229.9 211.475 229.9C215.222 229.9 218.724 228.777 221.595 226.872C221.887 226.676 222.179 226.481 222.471 226.237V283.384L284.111 236.982L251.321 215.149C250.591 214.661 250.153 213.83 250.153 212.951V193.511C250.153 191.46 252.44 190.19 254.191 191.265L309.605 226.237C312.767 228.142 314.81 231.512 315.005 235.224Z",
    fill: "#0B1023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.ed09035a70392f841ea8875a5e822bba.svg";
export { ForwardRef as ReactComponent };